function configure(Highcharts) {
    var merge = Highcharts.merge;
    var defaultPlotOptions = Highcharts.getOptions().plotOptions;
    //@ts-ignore
    var seriesTypes = Highcharts.seriesTypes;
    var extendClass = Highcharts.extendClass;
    var noop = function () { };
    var lineProto = seriesTypes.line.prototype;
    //@ts-ignore
    defaultPlotOptions.barline = merge(defaultPlotOptions.line, defaultPlotOptions.bar, {
        step: "center"
    });
    seriesTypes.barline = extendClass(seriesTypes.bar, {
        type: "barline",
        drawPoints: noop,
        drawGraph: lineProto.drawGraph
    });
}
export default configure;
